/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown>, pct: NonNullable<unknown> }} Wrapped_Period_Volume_DownInputs */

const en_us2_wrapped_period_volume_down = /** @type {(inputs: Wrapped_Period_Volume_DownInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`${i?.pct}% below the month before.`);
	return /** @type {LocalizedString} */ (`${i?.pct}% below the year before.`)
	
};

const pt_br2_wrapped_period_volume_down = /** @type {(inputs: Wrapped_Period_Volume_DownInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`${i?.pct}% abaixo do mês anterior.`);
	return /** @type {LocalizedString} */ (`${i?.pct}% abaixo do ano anterior.`)
	
};

const es_419_wrapped_period_volume_down = /** @type {(inputs: Wrapped_Period_Volume_DownInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`${i?.pct}% por debajo del mes anterior.`);
	return /** @type {LocalizedString} */ (`${i?.pct}% por debajo del año anterior.`)
	
};

const pt_pt2_wrapped_period_volume_down = /** @type {(inputs: Wrapped_Period_Volume_DownInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`${i?.pct}% abaixo do mês anterior.`);
	return /** @type {LocalizedString} */ (`${i?.pct}% abaixo do ano anterior.`)
	
};

const fr_fr2_wrapped_period_volume_down = /** @type {(inputs: Wrapped_Period_Volume_DownInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`${i?.pct} % de moins que le mois précédent.`);
	return /** @type {LocalizedString} */ (`${i?.pct} % de moins que l'année précédente.`)
	
};

const de_de2_wrapped_period_volume_down = /** @type {(inputs: Wrapped_Period_Volume_DownInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`${i?.pct}% unter dem Vormonat.`);
	return /** @type {LocalizedString} */ (`${i?.pct}% unter dem Vorjahr.`)
	
};

const it_it2_wrapped_period_volume_down = /** @type {(inputs: Wrapped_Period_Volume_DownInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`${i?.pct}% in meno rispetto al mese precedente.`);
	return /** @type {LocalizedString} */ (`${i?.pct}% in meno rispetto all'anno precedente.`)
	
};

/**
* | period | output |
* | --- | --- |
* | "month" | "{pct}% below the month before." |
* | * | "{pct}% below the year before." |
*
* @param {Wrapped_Period_Volume_DownInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_period_volume_down = /** @type {((inputs: Wrapped_Period_Volume_DownInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Period_Volume_DownInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_period_volume_down(inputs)
	if (locale === "es-419") return es_419_wrapped_period_volume_down(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_period_volume_down(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_period_volume_down(inputs)
	if (locale === "de-DE") return de_de2_wrapped_period_volume_down(inputs)
	if (locale === "it-IT") return it_it2_wrapped_period_volume_down(inputs)
	return en_us2_wrapped_period_volume_down(inputs)
});
export { wrapped_period_volume_down as "wrapped-period.volume_down" }